import React from 'react';
import { AlertTriangle, X } from 'lucide-react';

const DeleteConfirmationPopup = ({ isOpen, onClose, onConfirm, fleetName }) => {
    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
            <div className="bg-white rounded-2xl shadow-2xl max-w-md w-full mx-4 transform transition-all duration-300 scale-100">
                <div className="p-6">
                    <div className="flex items-center justify-between mb-4">
                        <div className="flex items-center gap-3">
                            <div className="w-12 h-12 bg-red-100 rounded-xl flex items-center justify-center">
                                <AlertTriangle className="w-6 h-6 text-red-600" />
                            </div>
                            <div>
                                <h3 className="text-lg font-bold text-gray-900">Delete Fleet</h3>
                                <p className="text-sm text-gray-600">This action cannot be undone</p>
                            </div>
                        </div>
                        <button
                            onClick={onClose}
                            className="p-2 hover:bg-gray-100 rounded-lg transition-colors"
                        >
                            <X className="w-5 h-5 text-gray-500" />
                        </button>
                    </div>

                    <div className="mb-6">
                        <p className="text-gray-700 mb-2">
                            Are you sure you want to delete <span className="font-semibold text-gray-900">{fleetName}</span>?
                        </p>
                        <p className="text-sm text-gray-600">
                            This will permanently remove this fleet from your system and cannot be reversed.
                        </p>
                    </div>

                    <div className="flex items-center gap-3 justify-end">
                        <button
                            onClick={onClose}
                            className="px-4 py-2.5 text-gray-700 bg-gray-100 hover:bg-gray-200 rounded-lg font-medium transition-all duration-200"
                        >
                            Cancel
                        </button>
                        <button
                            onClick={onConfirm}
                            className="px-4 py-2.5 bg-red-600 hover:bg-red-700 text-white rounded-lg font-medium transition-all duration-200 shadow-sm hover:shadow-md"
                        >
                            Delete Fleet
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default DeleteConfirmationPopup;